export const seniorDataScientistResume = `
【職務概要】
データサイエンスの世界で12年のキャリアを積み、多業種にわたるデータ活用事例に携わってきました。機械学習、統計的分析、アルゴリズム開発において高い専門性を持ち、特に金融業界と小売業界における予測モデルと異常検知の領域で多くの実績を残しています。近年はデータドリブン経営の浸透に伴い、経営層に対するデータ活用戦略の策定や、組織全体のデータリテラシー向上に貢献するプロジェクトを牽引。

単なる分析ではなく、ビジネス課題を適切に把握した上で、最適なデータ解析手法を選定し、経営判断に直結する形で分析結果を可視化・提案する一連のプロセスを得意としています。最新のAI技術動向を積極的に取り入れながらも、ビジネス価値創出を常に念頭に置いた実践的なデータサイエンティストとして、組織横断的なチームをリードし、大規模なデータプロジェクトの成功に導いてきました。

【職務経歴】
・株式会社Algomaticテクノロジー（2018年4月〜現在）
  ○ 会社概要：国内最大級のデータサイエンスコンサルティング企業。従業員数約300名、年商50億円。
  ○ 職務内容：シニアデータサイエンティスト／データサイエンス部門 統括マネージャー
    - 大手銀行向け企業劣化予測モデルの開発と導入
    - 小売業向け需要予測・在庫最適化アルゴリズムの構築
    - 製造業向け異常検知システムの開発と導入支援
    - データサイエンス部門（約30名）のマネジメントと育成
  ○ 具体的な成果：
    - 金融機関向け企業劣化予測モデル開発により与信判断精度が23%向上
    - 小売業向け需要予測システム導入により在庫削減率15%、機会損失6%減を実現
    - データサイエンティスト育成プログラムを構築、社内認定制度を確立し20名以上の若手育成に成功
  ○ 使用技術・ツール：Python, R, SQL, TensorFlow, PyTorch, Tableau, PowerBI, AWS, Azure
  ○ 身につけたスキル：大規模プロジェクト管理、経営層への提案力、組織マネジメント

・株式会社Algomaticソリューションズ（2014年5月〜2018年3月）
  ○ 会社概要：ビッグデータ分析とAI開発を主軸とするIT企業。従業員数約120名。
  ○ 職務内容：データサイエンティスト／プロジェクトリーダー
    - 通信キャリア向け顧客離反予測モデルの開発
    - ECサイト向けレコメンデーションエンジンの構築
    - データ分析チーム（5名）のマネジメント
  ○ 具体的な成果：
    - 顧客離反予測モデルにより年間約2億円の顧客維持効果を実現
    - レコメンデーションエンジン改善によりコンバージョン率18%向上
    - 社内データ分析基盤の構築とナレッジ共有システムの確立
  ○ 使用技術・ツール：Python, R, SQL, Hadoop, Spark, Tableau
  ○ 身につけたスキル：アルゴリズム開発、チームマネジメント、クライアントコミュニケーション

・株式会社Algomatic産業（2012年4月〜2014年4月）
  ○ 会社概要：大手製造業グループのデータ分析子会社。従業員数約80名。
  ○ 職務内容：データアナリスト
    - 製造ラインのセンサーデータ分析と異常検知
    - 営業データの分析と可視化
  ○ 具体的な成果：
    - 製造ライン不良率12%削減に貢献
    - 営業データ分析により重点顧客の選定精度向上
  ○ 使用技術・ツール：R, SPSS, SQL, Excel
  ○ 身につけたスキル：統計分析、データ可視化、製造業の業務知識

【受賞・表彰歴】
・2023年 株式会社Algomaticテクノロジー 年間MVP賞受賞
・2022年 日本データサイエンス学会 産業応用優秀事例賞（金融機関向け企業劣化予測モデル）
・2020年 Kaggle コンペティション 銀メダル（需要予測部門）
・2019年 社内イノベーション大賞（小売業向け在庫最適化アルゴリズム開発）

【資格】
・データサイエンティスト検定 エキスパート（2022年3月）
・統計検定 準1級（2019年11月）
・AWS 認定ソリューションアーキテクト - プロフェッショナル（2020年6月）
・G検定（2019年7月）
・E資格（2021年2月）
・Python3エンジニア認定データ分析試験（2018年8月）

【マネジメント経験】
・現職にて30名規模のデータサイエンス部門のマネジメント（2020年4月〜）
  ○ プロジェクト配置、評価、育成、採用などの人事業務全般
  ○ 年間約20件のデータ分析プロジェクト統括
  ○ ジュニアデータサイエンティスト向け育成プログラムの策定と実施
・株式会社Algomaticソリューションズにて5名のチームリーダー（2016年〜2018年）
  ○ 複数の顧客プロジェクトにおけるチームマネジメント
  ○ メンバーのスキル向上施策の立案と実施
  ○ 全メンバーの評価・目標設定面談の実施

【語学力】
・英語：ビジネスレベル
  ○ TOEIC 850点（2021年5月）
  ○ 海外顧客との英語によるミーティング経験あり
  ○ 英語論文や技術文書の読解・執筆経験あり
・中国語：日常会話レベル
  ○ 社内中国人エンジニアとのコミュニケーション可能
` as const;
